export let Status;

(function (Status) {
  Status["Idle"] = "IDLE";
  Status["Resolving"] = "RESOLVING";
  Status["Error"] = "ERROR";
  Status["Success"] = "SUCCESS";
})(Status || (Status = {}));
//# sourceMappingURL=constants.js.map